module.exports = __webpack_public_path__ + "static/img/facebook.2af89451.svg";